export default "__VITE_ASSET__BdyHY86F__"